module.exports = __webpack_public_path__ + "static/media/checkstyle06.5ef553b3.png";